import { createRouter, createWebHashHistory } from 'vue-router'
import { useLoginModalStore } from '@/stores/loginModal'
import { dispatchShowMobileGuide, isMobileBrowser } from '@/utils/mobileLayout'

/** 仅占位：实际登录 UI 由 LoginModal + 全局守卫处理，不替换当前页 */
const LoginRoutePlaceholder = { name: 'LoginRoutePlaceholder', render: () => null }

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: () => import('@/views/home/Index.vue'), meta: { tabBar: true } },
  { path: '/certificate', name: 'Certificate', component: () => import('@/views/certificate/Index.vue') },
  { path: '/theater', name: 'Theater', component: () => import('@/views/dev/theater-ui/Index.vue'), meta: { tabBar: true } },
  { path: '/theater/play', name: 'TheaterPlay', component: () => import('@/views/theater/Play.vue') },
  { path: '/theater/easter-egg', name: 'TheaterEasterEgg', component: () => import('@/views/theater/EasterEgg.vue') },
  { path: '/category', name: 'Category', component: () => import('@/views/category/Index.vue') },
  { path: '/upload', name: 'Upload', component: () => import('@/views/upload/Index.vue') },
  { path: '/profile', name: 'Profile', component: () => import('@/views/profile/Index.vue'), meta: { tabBar: true } },
  { path: '/user/profile', name: 'UserProfile', component: () => import('@/views/user/Profile.vue') },
  { path: '/user/edit-profile', name: 'EditProfile', component: () => import('@/views/user/EditProfile.vue') },
  { path: '/user/following', name: 'Following', component: () => import('@/views/user/Following.vue') },
  { path: '/user/followers', name: 'Followers', component: () => import('@/views/user/Followers.vue') },
  { path: '/settings', name: 'Settings', component: () => import('@/views/settings/Index.vue') },
  { path: '/login', name: 'Login', component: LoginRoutePlaceholder },
  { path: '/searchResult', name: 'SearchResult', component: () => import('@/views/searchResult/Index.vue') },
  { path: '/vip', name: 'Vip', component: () => import('@/views/vip/Index.vue') },
  { path: '/vip/pay', name: 'VipPay', component: () => import('@/views/vip/Pay.vue') },
  { path: '/vip/agreement', name: 'VipAgreement', component: () => import('@/views/agreement/VipService.vue') },
  { path: '/userpolicy', name: 'UserPolicy', component: () => import('@/views/agreement/UserPolicy.vue') },
  { path: '/member/detail', name: 'MemberDetail', component: () => import('@/views/member/Detail.vue') },
  { path: '/video/play', name: 'VideoPlay', component: () => import('@/views/video/Play.vue') },
  { path: '/shortVideoPrice', name: 'ShortVideoPrice', component: () => import('@/views/shortVideoPrice/Index.vue') },
  { path: '/adVideoPrice', name: 'AdVideoPrice', component: () => import('@/views/adVideoPrice/Index.vue') },
  {
    path: '/graphic/detail',
    name: 'GraphicDetail',
    component: () => import('@/views/graphic/Detail.vue'),
    meta: { hideGlobalHeader: true }
  },
  {
    path: '/ip-design/detail',
    name: 'IpDesignDetail',
    component: () => import('@/views/ip-design/Detail.vue'),
    meta: { hideGlobalHeader: true }
  },
  { path: '/video-list/hot', name: 'VideoListHot', component: () => import('@/views/video-list/Hot.vue') },
  { path: '/video-list/latest', name: 'VideoListLatest', component: () => import('@/views/video-list/Latest.vue') },
  { path: '/video-list/vip', name: 'VideoListVip', component: () => import('@/views/video-list/Vip.vue') },
  // 临时首页 UI 调试路由，仅开发使用
  { path: '/dev/home-ui', name: 'DevHomeUI', component: () => import('@/views/dev/HomeUiDev.vue') },
  // 剧场页 UI 调试：复制自 theater，仅在此改 UI，原 /theater 不变
  { path: '/theater-ui', name: 'TheaterUi', component: () => import('@/views/dev/theater-ui/Index.vue') },
  // 我的页 UI 调试：复制自 profile，仅在此改 UI，原 /profile 不变
  { path: '/dev/profile-ui', name: 'ProfileUi', component: () => import('@/views/dev/profile-ui/Index.vue') },
  // 编辑个人信息页 UI 调试：复制自 user/EditProfile，仅在此改样式，原 /user/edit-profile 不变
  { path: '/dev/edit-profile-ui', name: 'EditProfileUi', component: () => import('@/views/dev/edit-profile-ui/Index.vue') },
  // VIP 页 UI 调试：复制自 vip，仅在此改 UI，原 /vip 不变
  { path: '/dev/vip-ui', name: 'VipUi', component: () => import('@/views/dev/vip-ui/Index.vue') },
  // 视频播放页 UI 调试：复制自 video/Play，仅在此改 UI，原 /video/play 不变。访问 /dev/play-ui?id=xxx
  { path: '/dev/play-ui', name: 'PlayUi', component: () => import('@/views/dev/play-ui/Index.vue') },
  // 用户主页 UI 调试：复制自 user/Profile，仅在此改 UI，原 /user/profile 不变。访问 /dev/user-profile-ui 或 /dev/user-profile-ui?id=xxx
  { path: '/dev/user-profile-ui', name: 'UserProfileUi', component: () => import('@/views/dev/user-profile-ui/Index.vue') },
  // 剧集详情页已移除
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from) => {
  if (to.path !== '/login' && to.name !== 'Login') return true
  const cameFromInsideApp = from.matched.length > 0 && from.path !== '/login'
  if (isMobileBrowser()) {
    dispatchShowMobileGuide()
    if (cameFromInsideApp) return false
    return { path: '/home', replace: true }
  }
  const loginModalStore = useLoginModalStore()
  loginModalStore.open({ force: true })
  if (cameFromInsideApp) return false
  return { path: '/home', replace: true }
})

export default router
